import { useRef } from "react"
import { TextField,Box,Button } from "@mui/material"
import { addSuggestion, fetchSuggestions } from "../supabaseApi"

const SuggestionInput=({x,y,handleSuggestionInputOpen,authData,handleItemToPosition,handleRightPanel,item,lngLat,handleSuggestions})=>{
const suggestionInputRef=useRef('')

console.log(lngLat)
    return <Box sx={{position:'absolute',top:y+'px',left:x+'px', width:'200px',zIndex:3,backgroundColor:'white',padding:'20px',direction:'rtl'}}>
        <form onSubmit={async (e)=>{
            e.preventDefault();
            let title = (suggestionInputRef.current as unknown as HTMLInputElement).value
            await addSuggestion(item.id, lngLat.lat, lngLat.lng, title).catch(err=>console.log(err))
            let suggestions = await fetchSuggestions(item.id).catch(err=>console.log(err))
            handleSuggestions(suggestions || [])

        // handleSuggestionUpdate((suggestionInputRef.current as unknown as HTMLInputElement).value,lngLat)
        // setDoc(doc(db,'suggestions',item.id),{
        //     ...item,
        //     suggestions:arrayUnion({
        //         user: authData?.user?.displayName ?? "Guest",
        //         note:(suggestionInputRef.current as unknown as HTMLInputElement).value, 
        //         coordinates:new GeoPoint(lngLat.lat, lngLat.lng)
        //             //_long:lngLat.lng,_lat:lngLat.lat
        //         })},{merge:true})
        
        handleRightPanel(1)
        handleSuggestionInputOpen()
        handleItemToPosition(null)
        }
    }>
        <TextField
        autoFocus
        
        autoComplete="off"
        inputRef={e=>suggestionInputRef.current=e}
        placeholder="Comment (optional)"
        />
        <span style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
        <Button  type="submit">Confirm</Button>
        <Button onClick={()=>{
            handleSuggestionInputOpen()
        }}>ביטול</Button>
        </span>
        </form>
    </Box>

}

export default SuggestionInput